module.exports = __webpack_public_path__ + "img/logo.44b0597c.webp";